export default __webpack_public_path__ + "static/image-cv_sp-e8c6382167412b77ff33417cc6a69799.png";